module.exports = __webpack_public_path__ + "img/Monte_Kope_39.e0875a80.jpg";